module.exports = __webpack_public_path__ + "static/media/31.e385b3e7.jpg";